import { render, staticRenderFns } from "./CodeVerify.vue?vue&type=template&id=50ec571c&scoped=true&"
import script from "./CodeVerify.vue?vue&type=script&lang=js&"
export * from "./CodeVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec571c",
  null
  
)

export default component.exports